const activeFeaturedSliderBlocks = new Map();

class FeaturedSlider extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("shopify:block:select", this, this.onBlockSelect);

    const blockId = activeFeaturedSliderBlocks.get(this.dataset.sectionId);
    const index = this.elements.slides.findIndex((slide) => slide.dataset.blockId === blockId);

    this.show(index === -1 ? 0 : index);
  }

  onBlockSelect(event) {
    const index = this.elements.slides.indexOf(event.target);

    if (index !== -1) {
      this.show(index);
    }
  }

  next() {
    this.show(this.index + 1);
  }

  previous() {
    this.show(this.index - 1);
  }

  show(index) {
    const slides = this.elements.slides;

    this.index = (index + slides.length) % slides.length;

    if (window.Shopify?.designMode) {
      activeFeaturedSliderBlocks.set(this.dataset.sectionId, slides[this.index].dataset.blockId);
    }

    slides.forEach((slide, position) => {
      const active = position === this.index;

      slide.classList.toggle("active--true", active);
      slide.classList.toggle("active--false", !active);
      slide.inert = !active;
      slide.setAttribute("aria-hidden", String(!active));
    });
  }
}

customElements.define("component-featured-slider", FeaturedSlider);
